<template>
    <f-dialog
        v-if         = "contract"
        v-model      = "edit"
        :show-header = false
        :width       = "900"

        @cancel = "onCancel"
        @store  = "onSave"
    >
        <template v-slot:content>
            <v-form ref="form">
                <v-row class="no-frame mt-2">
                    <v-col class="no-frame col-6 pr-2">
                        <c-column-header
                            class="primary mb-1"
                            :label="$t('contract.title') + ' ' + title"
                        >
                            <template v-slot:filter>
                                <div class="contract-active">
                                    <v-checkbox
                                        v-model = "contract.active"
                                        label   = "aktiv"
                                        :ripple = "false"
                                        color   = "primary"
                                        class="ma-0 pa-0"
                                        hide-details
                                    />
                                </div>
                            </template>
                        </c-column-header>

                        <v-row class="no-frame lm-border pa-3 pt-0 mt-0">
                            <v-col class="no-frame">
                                <c-contract-header
                                    :contract      = "contract"
                                    :show-customer = "showCustomer"
                                    :show-title    = "false"
                                    :readonly      = "false"
                                    class          = "pt-2"
                                >
                                    <template v-slot:add>
                                        <slot name="add"></slot>
                                    </template>
                                    <template v-slot:post>
                                        <slot name="post"></slot>
                                    </template>
                                </c-contract-header>
                            </v-col>
                        </v-row>

                        <div class="pt-0 mt-3">
                            <div class="h-100">
                                <slot name="terms" />
                            </div>
                        </div>

                    </v-col>
                    <v-col class="no-frame col-6 mt-0 pl-2">
                        <v-row class="no-frame">
                            <v-col class="no-frame">
                                <c-column-header
                                    class="primary mt-0"
                                    :label="$t('contract.payment.title') "
                                >
                                    <template v-slot:filter>
                                        <div class="contract-active">
                                            <v-checkbox
                                                v-model   = "contract.invoiceInAdvance"
                                                label     = "im Voraus"
                                                :ripple   = "false"
                                                class="ma-0 pa-0"
                                                hide-details
                                            />
                                        </div>
                                    </template>
                                </c-column-header>

                                <c-contract-payment
                                    :contract   = "contract"
                                    :show-title = "false"
                                    :readonly   = "false"
                                    class=" lm-border pa-3 pt-2 mt-1"
                                    style="height: 162px;"
                                />
                            </v-col>
                        </v-row>
                        <v-row class="no-frame">
                            <v-col class="no-frame">
                                <c-column-header
                                    class="primary mt-2"
                                    :label="$t('contract.termsOfCancelation') "
                                />
                                <c-contract-toc
                                    :contract = "contract"
                                    :readonly = "false"
                                    :show-title = "false"
                                    class=" lm-border pa-3 pt-2 mt-1"
                                    style     = "height: 230px;"
                                />
                            </v-col>
                        </v-row>

                    </v-col>
                </v-row>
            </v-form>
        </template>
    </f-dialog>
</template>

<script>

import Core             from "@/modules/core/service/Core";
import Contract         from "@/modules/msd/company/contract/service/Contract";
import CContractHeader  from "@/modules/msd/company/contract/components/controls/CContractHeader";
import CContractToc     from "@/modules/msd/company/contract/components/controls/CContractToc";
import CContractPayment from "@/modules/msd/company/contract/components/controls/CContractPayment";
import FDialog          from "@/modules/core/components/utils/FDialog";
import CColumnHeader from "@/modules/core/components/utils/CColumnHeader";

export default {
    name: "DContractEdit",
    components: {
        CColumnHeader,
        CContractPayment,
        CContractToc,
        CContractHeader,
        FDialog
    },

    props: {
        value: {

        },

        title: {
            required: true,
            type    : String
        },

        typeId: {
            required: false,
            type    : Number,
        },

        contractId: {
            required: true,
            type    : Number
        },

        customerId: {
            required: false,
            type    : Number,
            default: function () {
                return null;
            }
        },

        companyId: {
            required: false,
            type    : Number,
            default: function () {
                return null;
            }
        },

        showCustomer: {
            required: false,
            type    : Boolean,
            default : function () {
                return true;
            }
        },
    },

    data: () => ({
        edit    : false,
        contract: null,
    }),

    mounted() {
        this.edit = this.value;
    },

    watch: {
        value () {
            if (this.value) {
                this.initialize();
            } else {
                this.edit = false;
            }
        },

        contractId () {
            this.initialize();
        }
    },

    methods: {
        initialize () {
            if (!this.contractId) {
                return;
            }

            if (this.contractId < 0) {
                Contract.create(this.customerId,  this.companyId, this.typeId, (data) => {
                    this.contract = data;
              //      this.$refs.form.validate ();
                    Core.fire.initialized(this, this.contract);
                })

                this.edit = this.value;
                return;
            }

            Contract.findById(this.contractId, (data) => {
                this.contract = data;
                Core.fire.initialized(this, this.contract);
                this.edit = this.value;
            });
        },

        onCancel () {
            this.$emit("input", false);
        },

        onSave () {
            if (!this.$refs.form.validate ()) {
                Core.message.confirm(
                    this,
                    this.$t("contract.payment.validation.query"),
                    this.$t("contract.payment.validation.text" ),
                    Core.message.Default,
                    (value) => {
                        if (!value) {
                            return;
                        }

                        this.save();
                    })
            } else {
                this.save();
            }
        },

        save () {
            if (this.contract.invoiceFrequency && this.contract.invoiceFrequency.id) {
                switch (this.contract.invoiceFrequency.id) {
                    case 2:
                        this.contract.invoicesPerYear = 12;
                        break;
                    case 3:
                        this.contract.invoicesPerYear = 4;
                        break;
                    case 4:
                        this.contract.invoicesPerYear = 2;
                        break;
                    case 5:
                        this.contract.invoicesPerYear = 1;
                        break;
                    default:
                        this.contract.invoicesPerYear = null;
                }
            }

            Contract.save(this.contract, (data) => {
                Core.message.alert.save(this);
                Core.fire.saved(this, data);
                this.$emit("input", false);
            })
        }
    }
}
</script>


<style scoped>

::v-deep .v-input--selection-controls__input {
    margin-right: 0!important;
}

.contract-active {
    background-color: white;
    padding-left: 4px;
    margin-right: 2px;
    margin-top: 2px;
    margin-bottom: 2px;
    border-radius: 2px;
    width: 100px;
    font-weight: 400;
}

::v-deep .contract-active .v-label {
    font-size: 13px;
}

</style>

